module.exports = __webpack_public_path__ + "img/elvina-rowjee.360ba6aa.png";